import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const textLinkStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  color: theme.colors.primary50,
  fontWeight: theme.font.weight.bold,
  cursor: 'pointer',
  ':hover': {
    textDecoration: 'none',
  },
});

export const insuranceBenefitSummaryAmountStyle = [
  css`
    .detail-text {
      font-weight: ${theme.font.weight.bold};
    }
    .total-amount {
      display: flex;
      align-items: center;
      font-weight: ${theme.font.weight.regular};
      font-size: ${theme.font.size.large};
    }
    .spent-amount {
      font-weight: ${theme.font.weight.bold};
      font-size: ${theme.font.size.h3};
    }
    dl:last-child {
      margin-bottom: 0;
    }
  `,
];
